import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const handleRetrieveAllSchedules = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      timeZone: data?.timeZone
    };
    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/schedule/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

export const handleUpdateSchedule = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/schedule/update`,
      },
      thunkAPI
    )
  }
)

export const handleDeleteSchedule = createAsyncThunk(
  "delete",
  async ({ day }, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/specialist/schedule/delete/${day}`,
      },
      thunkAPI
    )
  }
)

export const handleRejectAllAppointments = createAsyncThunk(
  "rejectAll",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data: {
          day: data.day,
          rejectReason: data.rejectReason
        },
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/schedule/rejectAll`,
      },
      thunkAPI
    );
  }
);